import React, {useState} from 'react';
import {Container, Card, Row, Col, CardBody} from 'react-bootstrap';
import { marked } from 'marked';
import myLogo from '../images/cmr_black_116.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFreeCodeCamp} from '@fortawesome/free-brands-svg-icons'
// import { faQuoteLeft, faCircleInfo } from '@fortawesome/free-solid-svg-icons'

export default function MarkdownPreviewer () {

     const [mdText, setMdText] = useState(`# Welcome to my React Markdown Previewer!
## This is a sub-heading...
### And here's some other cool stuff:
Heres some code, \`<div></div>\`, between 2 backticks.

// this is multi-line code:
\`\`\`
function anotherExample(firstLine, lastLine) {
if (firstLine == '\`\`\`' && lastLine == '\`\`\`') {
    return multiLineCode;
    }
}
\`\`\`

You can also make text **bold**... whoa!
Or _italic_.
Or... wait for it... **_both!_**
And feel free to go crazy ~~crossing stuff out~~.
There's also [links](https://www.beerbuddyfl.com), and
> Block Quotes!

- And of course there are lists.
    - Some are bulleted.
        - With different indentation levels.
            - That look like this.


1. And there are numbered lists too.
1. Use just 1s if you want!
1. And last but not least, let's not forget embedded images:

![Beer Buddy Logo](https://beerbuddyfl.com/img/bb-fl-logo.png)
`);

    marked.setOptions({
        breaks:true
    });

    return (
      <Container fluid="md">
        <Row className="justify-content-md-center">
          <div>
            <h2>CMR WEB Markdown Previewer</h2>
            <p>
              This app allows the user to enter GitHub style markup in the Code
              Editor and view a preview of the entered markup in the Preview
              Window.
            </p>

            <p>
              This project was created in React Bootstrap with JavaScript. As part of the freeCodeCamp <FontAwesomeIcon icon={faFreeCodeCamp} />{" "}
              Front End Development Libraries Certification Project.
            </p>

            <p className='float-end'>
                &copy; 2023 Christian M Rapp | CMR Web Studio
            </p>
          </div>
          <Col>
            <div className='cardHeading'>
            <img
                  className="logo"
                  src={myLogo}
                  height={30}
                  alt="CMR Web Logo"
                />{" "}
                Code Editor
            </div>
            <Card id="editorCard">
              <CardBody>
                <textarea
                  id="editor"
                  onChange={(event) => {
                    setMdText(event.target.value);
                  }}
                  value={mdText}
                ></textarea>
              </CardBody>
            </Card>
          </Col>

          <Col>
            <div className='cardHeading'>
            <img
                  className="logo"
                  src={myLogo}
                  height={30}
                  alt="CMR Web Logo"
                />{" "}
                Preview
            </div>
            <Card>
              <Card.Body>
                <Container>
                <div
                  id="preview"
                  dangerouslySetInnerHTML={{
                    __html: marked(mdText),
                  }}
                ></div>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );

}